import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function TeilnahmeForm({ formData, openState, stateChange, onSubmit }) {
  const [wert, setWert] = useState(formData?.status);
  const [text, setText] = useState("");
  const { t } = useTranslation();


  useEffect(() => {
    setWert(formData?.status);
  }, [formData]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData?.vst, wert, text);
  };

  const onClose = () => {
    stateChange(false);
  };

  return (
    <Dialog open={openState} onClose={onClose}>
      <DialogTitle>{t("Teilnahme bestätigen")}</DialogTitle>
      <DialogContent>
        <form id="teilnahme-form" onSubmit={handleSubmit}>
          <Select id="select" value={wert} label="Wähle eine Option" margin="dense" fullWidth onChange={(event) => setWert(event.target.value)}>
            <MenuItem value={1}>{t("Ich habe teilgenommen")}</MenuItem>
            <MenuItem value={2}>{t("Ich habe nicht teilgenommen")}</MenuItem>
          </Select>
          <TextField id="text" label="Text" multiline rows={4} value={text} margin="dense" fullWidth onChange={(event) => setText(event.target.value)}  />
        </form>
      </DialogContent>
      <DialogActions>
        <Button type="submit" form="teilnahme-form">
          {t("Bestätigen")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TeilnahmeForm;
